<template lang="pug">
  #team-overview
    .level.is-mobile
      .level-left
        .level-item
          WtTitle(card-title) Team Overview
      .level-right
        .level-item
          WtActionMenu(v-if="isJoined && (programLoaded && coreProgramMeta.memberCanManageTeams)")
            WtActionMenuItem.leave-team.has-text-danger(
              icon="account-minus"
              text="Leave"
              @click.native="leaveteam()"
            )
    figure.is-pulled-right
      p.image.is-96x96
        img.is-rounded(:src="_.get(team, 'logo', null)" alt="")
    .content
      p
        span.has-text-weight-semibold Type:&nbsp;
        span {{ teamType() }}
      p(v-if="_.get(team, 'description', false)")
        span.has-text-weight-semibold Team Description:&nbsp;
        span {{ team.description }}
      p(v-if="_.get(team, 'maxMembers', false) && _.get(team, 'numMembers', false)")
        span.has-text-weight-semibold Team Size:&nbsp;
        span {{ team.numMembers }} / {{ team.maxMembers }}
      p(v-if="_.get(team, 'initiationDate', false)")
        span.has-text-weight-semibold Created date:&nbsp;
        span {{ date(team.initiationDate, "DATE_FORMAT_FULL_MONTH").formatted }}
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "TeamOverview",

  components: {
    WtActionMenu,
    WtActionMenuItem,
    WtButton,
    WtTitle
  },

  mixins: [dateUtilityMixin],

  props: {
    team: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          description: null,
          public: null,
          inviteOnly: null,
          logo: null,
          maxMembers: null,
          numMembers: null,
          initiationDate: null
        };
      }
    }
  },

  computed: {
    ...mapGetters("members", ["memberTeams"]),
    ...mapGetters("program", ["programLoaded", "coreProgramMeta"]),

    isJoined() {
      const memberteamIds = this.memberTeams.map(item => item.id);
      return memberteamIds.includes(this.team.id);
    }
  },

  methods: {
    ...mapActions("teams", ["removeMembersFromTeam"]),
    ...mapActions(["snackBar"]),
    ...mapActions("pages", ["setPageLoaded"]),

    leaveteam() {
      this.$buefy.dialog.confirm({
        title: "Leave This team",
        confirmText: "Leave This team",
        type: "is-danger",
        hasIcon: true,
        message: "Are you sure you want to leave this team?",
        onConfirm: async () => {
          if (this.team.id) {
            await this.removeMembersFromTeam({
              teamId: this.team.id,
              memberIds: [this.$auth.user().id]
            }).then(response => {
              if (response && response.data.success) {
                // After leaving the team trigger a refetch for:
                // teams page and team detail page. NOTE: the teams page will not do a
                // full refetch if MyDashboard is "loaded". So, we also set MyDashboard to false.
                // TODO this.setPageLoaded({
                //   key: `team${this.team.id}`,
                //   value: false
                // }); --- currently team detail page refreshes on mount, v-if teamsLoaded and watcher on memberJoiningTeam
                this.setPageLoaded({
                  key: `MyDashboard`,
                  value: false
                });
                this.setPageLoaded({
                  key: `Teams`,
                  value: false
                });
                // using $router.push here to
                // go back to the teams page, which
                // triggers the fetchAllMixin to re-load data
                this.$router.push({ name: "Teams" });

                this.snackBar({
                  duration: 5000,
                  type: "is-success",
                  message: "You are no longer a member of: " + this.team.name
                });
              }
            });
          }
        }
      });
    },

    teamType() {
      const type = this._.get(this.team, "inviteOnly", false);

      return type ? "Public/Invite Only" : "Public/Open";
    }
  }
};
</script>

<style lang="sass" scoped></style>
